function htmlDecode(html) {
    return html.replace(/&([a-z]+);/gi, (match, entity) => {
        const entities = {
            amp: "&",
            apos: "'",
            gt: ">",
            lt: "<",
            nbsp: "\xa0",
            quot: '"',
        };
        entity = entity.toLowerCase();
        if (entities.hasOwnProperty(entity)) {
            return entities[entity];
        }
        return match;
    });
}

export default htmlDecode;
